export default __webpack_public_path__ + "static/media/cross.5398d98c.svg";